/** @format */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgxFudisModule } from '@funidata/ngx-fudis';
import { TranslateModule } from '@ngx-translate/core';
import { SisCommonModule } from 'sis-common';
import { EnrolmentModule, SisComponentsModule } from 'sis-components';
import { StudentCommonModule } from '../../common/common.module';
import { OpenUniversityCommonModule } from '../common/open-university-common.module';
import { AddToCartButtonComponent } from './add-to-cart-button/add-to-cart-button.component';
import { AssessmentItemTeachingComponent } from './assessment-item-teaching/assessment-item-teaching.component';
import { CarouselProductInfoComponent } from './carousel-product-info/carousel-product-info.component';
import { DifferentVersionPurchasesComponent } from './different-version-purchases/different-version-purchases.component';
import { OpenUniversityCourseUnitRealisationInfoComponent } from './open-university-course-unit-realisation-info/open-university-course-unit-realisation-info.component';
import { OpenUniversityOfferingComponent } from './open-university-offering/open-university-offering.component';
import { ProductCarouselComponent } from './product-carousel/product-carousel.component';
import { ProductSlideBannerPipe } from './product-carousel/product-slide-banner.pipe';
import { ProductDetailsComponent } from './product-details/product-details.component';
import { PurchasedProductBasicInfoComponent } from './purchased-product-basic-info/purchased-product-basic-info-component';

@NgModule({
    declarations: [
        AddToCartButtonComponent,
        AssessmentItemTeachingComponent,
        CarouselProductInfoComponent,
        OpenUniversityCourseUnitRealisationInfoComponent,
        OpenUniversityOfferingComponent,
        DifferentVersionPurchasesComponent,
        ProductCarouselComponent,
        ProductDetailsComponent,
        ProductSlideBannerPipe,
        PurchasedProductBasicInfoComponent,
    ],
    imports: [
        CommonModule,
        EnrolmentModule,
        OpenUniversityCommonModule,
        SisCommonModule,
        SisComponentsModule,
        StudentCommonModule,
        TranslateModule.forChild(),
        NgxFudisModule,
    ],
    exports: [OpenUniversityOfferingComponent],
})
export class StudyOfferingModule {}
